import { useEffect, useState } from 'react';

/**
 * O ponteiro é um dedo?
 *
 * Diferente de "a tela é estreita": um tablet de 1200 px é dedo e um celular
 * ligado a um teclado com mouse não é. Onde a pergunta é de precisão do
 * ponteiro — tamanho de alvo, atalho de teclado, `title` que ninguém vê — é
 * esta que vale, e não a largura.
 *
 * Para tamanho e espaçamento prefira a variante `pointer-coarse:` do Tailwind,
 * que resolve no CSS e não custa render. Este gancho é para o que só o
 * JavaScript decide, como o Enter do compositor.
 */
export function usarDedo(): boolean {
  const [dedo, setDedo] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches,
  );

  useEffect(() => {
    const consulta = window.matchMedia('(pointer: coarse)');
    const aoMudar = (): void => setDedo(consulta.matches);
    aoMudar();
    consulta.addEventListener('change', aoMudar);
    return () => consulta.removeEventListener('change', aoMudar);
  }, []);

  return dedo;
}
